module.exports = __webpack_public_path__ + "img/watchTV.f252c8fb.svg";